/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS GPS lost detection api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatVoyPosReportSchemaInput
 */
export interface StatVoyPosReportSchemaInput {
    /**
     * Unique identifier for the record
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    id?: any | null;
    /**
     * Universal unique identifier for the record
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    uuid?: any | null;
    /**
     * Created at this point in time
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    createdAt?: any | null;
    /**
     * Created by this user
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    createdBy?: any | null;
    /**
     * Modified at this point in time
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    modifiedAt?: any | null;
    /**
     * Modified by this user
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    modifiedBy?: any | null;
    /**
     * Maritime Mobile Service Identity
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    mmsi: any | null;
    /**
     * Base Station Timestamp
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    bsTs: any | null;
    /**
     * Device used for position (1=GPS)
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    deviceForPos: any | null;
    /**
     * Position of the ship in geojson
     * @type {{ [key: string]: any; }}
     * @memberof StatVoyPosReportSchemaInput
     */
    position: { [key: string]: any; } | null;
    /**
     * Speed over ground in knots
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    sog: any | null;
    /**
     * The position accuracy: 1 = high (<= 10 m), 0 = low (> 10 m)
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    posAccuracy: any | null;
    /**
     * International Maritime Organization number
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    imo: any | null;
    /**
     * Name of the ship
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    name: any | null;
    /**
     * Type of the ship
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    typeShipCargo: any | null;
    /**
     * Draught of the ship in meters
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    draught: any | null;
    /**
     * Destination of the ship
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    destination: any | null;
    /**
     * Estimated time of arrival
     * @type {any}
     * @memberof StatVoyPosReportSchemaInput
     */
    eta: any | null;
}

/**
 * Check if a given object implements the StatVoyPosReportSchemaInput interface.
 */
export function instanceOfStatVoyPosReportSchemaInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mmsi" in value;
    isInstance = isInstance && "bsTs" in value;
    isInstance = isInstance && "deviceForPos" in value;
    isInstance = isInstance && "position" in value;
    isInstance = isInstance && "sog" in value;
    isInstance = isInstance && "posAccuracy" in value;
    isInstance = isInstance && "imo" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "typeShipCargo" in value;
    isInstance = isInstance && "draught" in value;
    isInstance = isInstance && "destination" in value;
    isInstance = isInstance && "eta" in value;

    return isInstance;
}

export function StatVoyPosReportSchemaInputFromJSON(json: any): StatVoyPosReportSchemaInput {
    return StatVoyPosReportSchemaInputFromJSONTyped(json, false);
}

export function StatVoyPosReportSchemaInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatVoyPosReportSchemaInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
        'createdAt': !exists(json, 'created_at') ? undefined : json['created_at'],
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
        'modifiedAt': !exists(json, 'modified_at') ? undefined : json['modified_at'],
        'modifiedBy': !exists(json, 'modified_by') ? undefined : json['modified_by'],
        'mmsi': json['mmsi'],
        'bsTs': json['bs_ts'],
        'deviceForPos': json['device_for_pos'],
        'position': json['position'],
        'sog': json['sog'],
        'posAccuracy': json['pos_accuracy'],
        'imo': json['imo'],
        'name': json['name'],
        'typeShipCargo': json['type_ship_cargo'],
        'draught': json['draught'],
        'destination': json['destination'],
        'eta': json['eta'],
    };
}

export function StatVoyPosReportSchemaInputToJSON(value?: StatVoyPosReportSchemaInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'uuid': value.uuid,
        'created_at': value.createdAt,
        'created_by': value.createdBy,
        'modified_at': value.modifiedAt,
        'modified_by': value.modifiedBy,
        'mmsi': value.mmsi,
        'bs_ts': value.bsTs,
        'device_for_pos': value.deviceForPos,
        'position': value.position,
        'sog': value.sog,
        'pos_accuracy': value.posAccuracy,
        'imo': value.imo,
        'name': value.name,
        'type_ship_cargo': value.typeShipCargo,
        'draught': value.draught,
        'destination': value.destination,
        'eta': value.eta,
    };
}

